import React from 'react'

import { Pluralize } from '@sketch/components'
import { formatByteCount } from '@sketch/utils'
import { thumbnailForPreviewFile } from '@sketch/modules-common'
import { DownloadableAssetRenderedNotificationFragment } from '@sketch/gql-types'

import { DownloadIcon } from './DownloadableAssetPreview.styles'
import { DocumentTileMedia } from './DocumentTileMedia'
import { DownloadAction } from './InboxPreviewActions'
import {
  Card,
  IconTile,
  Separator,
  Tile,
  TileMeta,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface DownloadableAssetPreviewProps {
  notification: DownloadableAssetRenderedNotificationFragment
}

export const DownloadableAssetPreview = ({
  notification,
}: DownloadableAssetPreviewProps) => {
  const { share, workspace } = notification
  const asset = notification.notifiedVersion?.document?.downloadableAssets[0]

  if (!asset || !share) return null

  const assetCount = asset.layerUuids.length
  const size =
    asset.fileSizeInBytes != null
      ? formatByteCount(asset.fileSizeInBytes)
      : null
  const thumbnail = thumbnailForPreviewFile(
    notification.notifiedVersion?.document?.previewFile
  )

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <IconTile aria-hidden>
            <DownloadIcon />
          </IconTile>
          <Pluralize
            singular="asset"
            count={assetCount}
            showCount
            wrapperElement={TileTitle}
          />
          {size && <TileMeta>{size}</TileMeta>}
          <TileMeta>ZIP</TileMeta>
        </Tile>

        <Separator />

        <Tile>
          <DocumentTileMedia src={thumbnail} alt={`Preview of ${share.name}`} />
          <TileTitle>{share.name}</TileTitle>
          {share.project?.name && <TileMeta>{share.project.name}</TileMeta>}
          {workspace?.name && <TileMeta>{workspace.name}</TileMeta>}
        </Tile>
      </TileWrapper>

      {asset.status === 'AVAILABLE' && asset.path && (
        <DownloadAction
          identifier={notification.identifier}
          assetPath={asset.path}
        />
      )}
    </Card>
  )
}
